// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__hnt9B","checkboxCol":"Table_checkboxCol__2MJ-i","emailCol":"Table_emailCol__58VHw","actionCol":"Table_actionCol__3KqRi"};